var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C2.688 12 0 9.318 0 6C0 2.688 2.688 0 6 0C9.318 0 12 2.688 12 6C12 9.318 9.318 12 6 12ZM7.914 8.22612C7.986 8.26812 8.064 8.29212 8.148 8.29212C8.298 8.29212 8.448 8.21412 8.532 8.07012C8.658 7.86012 8.592 7.58412 8.376 7.45212L6.24 6.18012V3.40812C6.24 3.15612 6.036 2.95812 5.79 2.95812C5.544 2.95812 5.34 3.15612 5.34 3.40812V6.43812C5.34 6.59412 5.424 6.73812 5.562 6.82212L7.914 8.22612Z",
    fill: "#A5A6BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchIcon);
export default __webpack_public_path__ + "static/media/watch-icon.d297f2b278e2fc32ee2b5b3888ede62a.svg";
export { ForwardRef as ReactComponent };